<mat-card class="card">
  <mat-card-content>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
